<template>
    <div class="competitionDetail">
        <div class="leftBox">
            <ul>
                <li>
                    <p class="name">
                        <span class="circle"></span>
                        竞赛类别：
                    </p>
                    <p class="detail">{{getType(form.type)}}</p>
                </li>
                <li>
                    <p class="name">
                        <span class="circle"></span>
                        赛事名称：
                    </p>
                    <p class="detail">{{form.name}}</p>
                </li>
                <li>
                    <p class="name">
                        <span class="circle"></span>
                        奖项等级：
                    </p>
                    <p class="detail">{{form.degree}}</p>
                </li>
                <li>
                    <p class="name">
                        <span class="circle"></span>
                        获奖时间：
                    </p>
                    <p class="detail">{{form.date}}</p>
                </li>
                <li>
                    <p class="name">
                        <span class="circle"></span>
                        组织单位：
                    </p>
                    <p class="detail">{{form.organizationalUnit}}</p>
                </li>
                <li>
                    <p class="name">
                        <span class="circle"></span>
                        获奖类型：
                    </p>
                    <p class="detail">{{getPersonalTeam(form.personalTeam)}}</p>
                </li>
            </ul>
        </div>
        <div class="rightBox" v-if="form.picUrl&&form.picUrl.length"  >
            <div class="swiper">
                <ul :style="{ marginLeft: -swiperIndex*270 + 'px' }">
                    <li v-for="(value,index) in form.picUrl" :key="index">
                        <img
                            :src="value.url|| '/acapi' + value"
                            @click="openImg(value)"
                            alt=""
                        />
                    </li>
                </ul>
            </div>
            <div class="btnBox">
                <div class="leftBtn btn" @click="changeSwiper(-1)" ><img src="~@img/xueyezixun/consultant/student/mine/icon_left.png" alt=""/></div>
                <div class="rightBtn btn" @click="changeSwiper(1)"><img src='~@img/xueyezixun/consultant/student/mine/icon_right.png' alt=""/></div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
export default {
    name: "competitionDetailBox",
    props: ['form'],
    components: {
        Button
    },
    data() {
        return {
            swiperIndex: 0,
            // type: '',//1五大学科类 2科技创新类 3人文社科类 4国际赛事类 5其他
            // name: '',//赛事名称
            // degree: '',//奖项等级
            // date: null,//获奖日期
            // organizationalUnit: '',//组织单位
            // personalTeam: '',//奖项类型 1个人 2团体
            // picUrl: []//上传图片
        }
    },
    created() {
    },
    methods: {

        openImg(value) {
            window.open(value.url||'http://zq.api.chencaiwang.com' + value);
        },
        changeSwiper(value) {
            let length = this.form.picUrl.length;
            let swiperIndex = this.swiperIndex;
            if(value>0) {
                if(swiperIndex === length-1){
                    return;
                }
                swiperIndex ++;
                this.swiperIndex = swiperIndex;
            }else {
                if(swiperIndex === 0){
                    return;
                }
                swiperIndex --;
                this.swiperIndex = swiperIndex;
            }
        },
        getType(type) {
            // type: '',//1五大学科类 2科技创新类 3人文社科类 4国际赛事类 5其他
            switch(Number(type)) {
                case 1:
                    return '五大学科类'
                    break;
                case 2:
                    return '科技创新类'
                    break;
                case 3:
                    return '人文社科类'
                    break;
                case 4:
                    return '国际赛事'
                    break;
                case 5:
                    return '其他'
                    break;
            }

        },
        getPersonalTeam(personalTeam) {
            // personalTeam: '',//1团体
            switch(Number(personalTeam)) {
                case 1:
                    return '团体'
                    break;
                case 2:
                    return '个人'
                    break;
            }
        }
    },
}
</script>
<style scoped lang="less">
.competitionDetail {
        height: 384px;
        display: flex;
        align-items: center;
        background-color: #fff;
        padding: 0px 130px 20px 130px;
        .name {
            font-size: 16px;
            display: flex;
            align-items: center;
            line-height: 24px;
            .circle {
                width: 12px;
                height: 12px;
                background: #00A2FF;
                border: 2px solid #D4F0FF;
                border-radius: 50%;
                margin-right: 5px;
            }
        }
        .leftBox {
            width: 360px;
            ul {
                li {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    height: 24px;
                    line-height: 24px;
                    margin-bottom: 24px;

                    .detail {
                        padding-left: 20px;
                        font-weight: bold;
                    }
                }
            }
        }
        .rightBox {
            width: 350px;
            padding: 0 40px;
            position: relative;
            .btnBox {
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -19px;
                width: 100%;
                height: 38px;
                .btn {
                    width: 30px;
                    height: 30px;
                }
                .leftBtn {
                    position: absolute;
                    left: 0;
                    //background-color: #3492f9;
                }
                .rightBtn {
                    position: absolute;
                    right: 0;
                    //background-color: #3492f9;
                }
            }
            .swiper {
                width: 270px;
                height: 384px;
                overflow: hidden;
            }
            ul {
                width: 1300px;
                height: 384px;
                transition: all .3s;
                li {
                    width: 270px;
                    height: 384px;
                    display: flex;
                    align-items: center;
                    float: left;
                    img {
                        display: inline-block;
                        width: 100%;
                    }
                }
            }

        }

}
</style>